import classNames from 'classnames';
import React from 'react';
import GoogleDot from '../../images/google_dot.png';
import MicrosoftDot from '../../images/microsoft_dot.svg';
const dotCss = "dm04c9a";
const externalDotImgCss = "e1ejh07l";
const fadedCss = "f12tnhy";
const EXTERNAL_DOT_MAP: Record<string, string> = {
  GOOGLE: GoogleDot,
  OUTLOOK: MicrosoftDot
};
interface MeetingDotProps {
  source: string;
  color: string;
  isPast: boolean;
  isCancelled: boolean;
}

/**
 * Renders a visual indicator dot for a meeting card.
 *
 * For external calendar sources (Google, Outlook), renders the provider's
 * logo image. For all other sources, renders a colored circle using the
 * event type color. The dot is faded when the meeting is past or cancelled.
 *
 * @param source - The calendar source identifier (e.g. "GOOGLE", "OUTLOOK")
 * @param color - CSS color value used for the dot background
 * @param isPast - Whether the meeting has already occurred
 * @param isCancelled - Whether the meeting has been cancelled
 */
export const MeetingDot = ({
  source,
  color,
  isPast,
  isCancelled
}: MeetingDotProps) => {
  const isExternal = source in EXTERNAL_DOT_MAP;
  const externalSrc = EXTERNAL_DOT_MAP[source];
  const fadedClasses = {
    [fadedCss]: isPast || isCancelled
  };
  return isExternal ? <img alt="logo-icon" src={externalSrc} className={classNames(externalDotImgCss, fadedClasses)} /> : <div className={classNames(dotCss, fadedClasses)} {...{
    style: {
      '--dot-color': color
    } as React.CSSProperties
  }} />;
};

require("./MeetingDot.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MeetingDot.tsx");